/***
 * Make first letter uppercase.
 *
 * @param {string} str
 * @returns {string}
 */
function upFirstLetter(str: string): string {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export default upFirstLetter;